import { connect } from 'react-redux';

import * as bucketConstants from '../../constants/buckets';
import ChangeUserRole from '../../components/ChangeUserRole';

const mapDispatchToProps = dispatch => ({
    onSubmit: payload =>
        dispatch({
            type: bucketConstants.CHANGE_USERS_ROLE_REQUEST,
            payload,
        }),
});

export default connect(
    undefined,
    mapDispatchToProps,
)(ChangeUserRole);



// WEBPACK FOOTER //
// ./src/containers/appDialog/ChangeUserRoleInBucket.js